import * as opportunity from '@product/store/modules/opportunity'
import * as accountCreatedLoader from './accountCreatedLoader'
import * as aggregator from './aggregator'
import * as apiDeck from './apiDeck'
import * as auth from './auth'
import * as bank from './bank'
import * as cashFlow from './cashFlowForecast'
import * as company from './company'
import * as creditScore from './creditScore'
import * as currentFormDetails from './currentFormDetails'
import * as displayModals from './displayModals'
import * as dynamicFormList from './dynamicFormList'
import * as formFields from './formFields'
import * as formMetaData from './formMetaData'
import * as geometricBackground from './geometricBackground'
import * as goalsStepCounter from './goalsStepCounter'
import * as illionIframeRoutine from './illion'
import * as legacyLoansData from './legacyLoansData'
import * as navigationBars from './navigationBars'
import * as notification from './notification'
import * as notificationMessages from './notificationMessages'
import * as onboarding from './onboarding'
import * as plaid from './plaid'
import * as sidebar from './sidebar'
import * as sortBar from './sortBar'
import stage from './stage'
import * as swoopAssistant from './swoopAssistant'
import * as transition from './transition'
import * as xero from './xero'
import * as applications from './applications'

export default {
  xero,
  auth,
  bank,
  plaid,
  applications,
  sidebar,
  company,
  sortBar,
  apiDeck,
  formFields,
  onboarding,
  aggregator,
  transition,
  creditScore,
  accountCreatedLoader,
  formMetaData,
  opportunity,
  notification,
  swoopAssistant,
  navigationBars,
  dynamicFormList,
  legacyLoansData,
  goalsStepCounter,
  currentFormDetails,
  geometricBackground,
  notificationMessages,
  illionIframeRoutine,
  cashFlow,
  displayModals,
  stage
}
